import { render, staticRenderFns } from "./GlucoseCreation.vue?vue&type=template&id=bb1c73a2&scoped=true"
import script from "./GlucoseCreation.vue?vue&type=script&lang=js"
export * from "./GlucoseCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1c73a2",
  null
  
)

export default component.exports